const t = "{{currentTime}} su {{duration}}", o = "{{current}} risultati di ricerca su {{total}}", i = "Nessun risultato trovato", n = "{{count}} risultato trovato", c = "{{count}} risultati trovati", s = 'Gioco in corso da $t(HOURS, { "count": {{hours}} }), $t(MINUTES, { "count": {{minutes}} }) e $t(SECONDS, { "count": {{seconds}} }).', e = 'Gioco in corso da $t(MINUTES, { "count": {{minutes}} }) e $t(SECONDS, { "count": {{seconds}} }).', A = 'Gioco in corso da $t(SECONDS, { "count": {{seconds}} }).', a = "Errore durante il salvataggio delle modifiche al libretto.", E = "Linea libretto alle {{time}}. Il contenuto è: {{text}}.", T = 'Contenitore linee libretto. Ci sono $t(TRANSCRIPT_LINES, { "count": {{count}} }) all’interno di questo contenitore. Per navigare in questo contenitore utilizzare il tasto freccia giù.', _ = "Salvataggio modifiche in corso...", r = "Modifiche salvante per libretto.", S = "Il pulsante Aggiorna sottotitolo è ora disponibile.", R = "Azione", u = "Aggiungi annotazione alle {{time}}", N = "Aggiungi domanda a {{time}}", l = "Annotazioni", I = "Auto", O = "Auto ({{quality}})", C = "Indietro", P = "Sottotitoli", U = "Lingua sottotitoli", L = "Gestisci sottotitoli", d = "Elimina {{language}}", D = "Dimensione font", M = "Lingua sottotitolo: {{language}}", m = "{{language}} (automatico)", p = "Cancella ricerca", v = "Chiudi", g = "Commenti", G = "Continua", Y = "Riduci velocità di riproduzione", z = "Riduci volume di {{percent}}%", V = "Freccia giù", H = "Chiudi editor libretto", b = "Aggiorna sottotitoli", B = "Errore!", F = "Salvataggio in corso...", h = "Salvato.", K = "Modifica libretto", f = "Il testo non può essere vuoto!", Q = "Tutto schermo", W = "{{count}} ora", $ = "{{count}} ore", q = "Aumenta velocità di riproduzione", J = "Aumenta volume di {{percent}}%", x = "Inverti colori", Z = "Passa a percentuale specifica (1-10%, 2-20%, ecc.)", y = "Passa ad Avvia", X = "Azioni per {{title}}", j = "Scelte rapide da tastiera", k = "Lingua", w = "Freccia sinistra", tt = "Menu principale", ot = "{{count}} minuto", it = "{{count}} minuti", nt = "Disattivato", ct = "Disattivata", st = "Lingua sottotitolo successivo", et = "Risultato ricerca successivo", At = "Off", at = "In alto", Et = "Apri annotazione alle  {{time}}", Tt = "Apri quiz completato alle {{time}}", _t = "Apri quiz alle {{time}}", rt = "Pausa", St = "Riproduci", Rt = "Velocità di riproduzione", ut = "Velocità di riproduzione: {{speed}}x", Nt = "Lingua sottotitolo precedente", lt = "Risultato ricerca precedente", It = "Qualità", Ot = "Menu Qualità", Ct = "Replay", Pt = "Reimposta velocità di riproduzione", Ut = "Freccia destra", Lt = "Cerca in libretto", dt = "{{count}} secondo", Dt = "{{count}} secondi", Mt = "Cerca indietro: {{seconds}} secondi", mt = "Cerca avanti: {{seconds}} secondi", pt = "Impostazioni", vt = "Scorciatoia", gt = "Dettagli e strumenti multimediali", Gt = "Spazio", Yt = "Menu Velocità di riproduzione", zt = "Avvia scorrimento automatico", Vt = "Attiva/Disattiva sottotitoli", Ht = "Attiva/Disattiva tacitazione", bt = "Attiva/Disattiva riproduzione/pausa", Bt = "è {{count}} linea libretto", Ft = "sono {{count}} linee libretto", ht = "Caricamento libretto in corso...", Kt = "Impossibile caricare il libretto.", ft = "Opzioni libretto", Qt = "Riprova", Wt = "Libretto non disponibile", $t = "Freccia su", qt = "Impostazioni video", Jt = "Volume", xt = "Volume: {{volume}}%", Zt = {
  A11Y_DURATION: t,
  A11Y_SEARCH_HITS: o,
  A11Y_SEARCH_NO_RESULTS: i,
  A11Y_SEARCH_RESULTS_FOUND: n,
  A11Y_SEARCH_RESULTS_FOUND_other: c,
  A11Y_TIMESTAMP_JUMP_HOURS: s,
  A11Y_TIMESTAMP_JUMP_MINUTES: e,
  A11Y_TIMESTAMP_JUMP_SECONDS: A,
  A11Y_TRANSCRIPT_ERROR: a,
  A11Y_TRANSCRIPT_LINE: E,
  A11Y_TRANSCRIPT_LINES: T,
  A11Y_TRANSCRIPT_SAVING: _,
  A11Y_TRANSCRIPT_SUCCESS: r,
  A11Y_UPDATE_CAPTIONS_AVAILABLE: S,
  ACTION: R,
  ADD_ANNOTATION_AT: u,
  ADD_QUESTION_AT: N,
  ANNOTATIONS: l,
  AUTO: I,
  AUTO_QUALITY: O,
  BACK: C,
  CAPTIONS: P,
  CAPTIONS_LANGUAGE: U,
  CAPTIONS_MANAGE: L,
  CAPTION_DELETE: d,
  CAPTION_FONT_SIZE: D,
  CAPTION_LANGUAGE: M,
  CAPTION_LANGUAGE_AUTOMATIC: m,
  CLEAR_SEARCH: p,
  CLOSE: v,
  COMMENTS: g,
  CONTINUE: G,
  DECREASE_PLAYBACK_SPEED: Y,
  DECREASE_VOLUME: z,
  DOWN_ARROW: V,
  EDIT_CLOSE: H,
  EDIT_CONFIRM: b,
  EDIT_ERROR: B,
  EDIT_SAVING: F,
  EDIT_SUCCESS: h,
  EDIT_TRANSCRIPT: K,
  EDIT_VALIDATION_ERROR: f,
  FULLSCREEN: Q,
  HOURS: W,
  HOURS_other: $,
  INCREASE_PLAYBACK_SPEED: q,
  INCREASE_VOLUME: J,
  INVERT_COLORS: x,
  JUMP_TO_PERCENTAGE: Z,
  JUMP_TO_START: y,
  KEBAB_MENU: X,
  KEYBOARD_SHORTCUTS: j,
  LANGUAGE: k,
  LEFT_ARROW: w,
  MAIN_MENU: tt,
  MINUTES: ot,
  MINUTES_other: it,
  MUTE: nt,
  MUTED: ct,
  NEXT_CAPTION_LANGUAGE: st,
  NEXT_HIT: et,
  OFF: At,
  ON_TOP: at,
  OPEN_ANNOTATION_AT: Et,
  OPEN_COMPLETED_QUIZ_AT: Tt,
  OPEN_QUIZ_AT: _t,
  PAUSE: rt,
  PLAY: St,
  PLAYBACK_SPEED: Rt,
  PLAYBACK_SPEED_MESSAGE: ut,
  PREVIOUS_CAPTION_LANGUAGE: Nt,
  PREVIOUS_HIT: lt,
  QUALITY: It,
  QUALITY_MENU: Ot,
  REPLAY: Ct,
  RESET_PLAYBACK_SPEED: Pt,
  RIGHT_ARROW: Ut,
  SEARCH_TRANSCRIPT_PLACEHOLDER: Lt,
  SECONDS: dt,
  SECONDS_other: Dt,
  SEEK_BACKWARD: Mt,
  SEEK_FORWARD: mt,
  SETTINGS: pt,
  SHORTCUT: vt,
  SIDEBAR: gt,
  SPACE: Gt,
  SPEED_MENU: Yt,
  START_AUTOSCROLL: zt,
  TOGGLE_CAPTIONS: Vt,
  TOGGLE_MUTED: Ht,
  TOGGLE_PLAY_PAUSE: bt,
  TRANSCRIPT_LINES: Bt,
  TRANSCRIPT_LINES_other: Ft,
  TRANSCRIPT_LOADING: ht,
  TRANSCRIPT_LOAD_ERROR: Kt,
  TRANSCRIPT_OPTIONS: ft,
  TRANSCRIPT_RETRY: Qt,
  TRANSCRIPT_UNAVAILABLE: Wt,
  UP_ARROW: $t,
  VIDEO_SETTINGS: qt,
  VOLUME: Jt,
  VOLUME_VALUE: xt
};
export {
  t as A11Y_DURATION,
  o as A11Y_SEARCH_HITS,
  i as A11Y_SEARCH_NO_RESULTS,
  n as A11Y_SEARCH_RESULTS_FOUND,
  c as A11Y_SEARCH_RESULTS_FOUND_other,
  s as A11Y_TIMESTAMP_JUMP_HOURS,
  e as A11Y_TIMESTAMP_JUMP_MINUTES,
  A as A11Y_TIMESTAMP_JUMP_SECONDS,
  a as A11Y_TRANSCRIPT_ERROR,
  E as A11Y_TRANSCRIPT_LINE,
  T as A11Y_TRANSCRIPT_LINES,
  _ as A11Y_TRANSCRIPT_SAVING,
  r as A11Y_TRANSCRIPT_SUCCESS,
  S as A11Y_UPDATE_CAPTIONS_AVAILABLE,
  R as ACTION,
  u as ADD_ANNOTATION_AT,
  N as ADD_QUESTION_AT,
  l as ANNOTATIONS,
  I as AUTO,
  O as AUTO_QUALITY,
  C as BACK,
  P as CAPTIONS,
  U as CAPTIONS_LANGUAGE,
  L as CAPTIONS_MANAGE,
  d as CAPTION_DELETE,
  D as CAPTION_FONT_SIZE,
  M as CAPTION_LANGUAGE,
  m as CAPTION_LANGUAGE_AUTOMATIC,
  p as CLEAR_SEARCH,
  v as CLOSE,
  g as COMMENTS,
  G as CONTINUE,
  Y as DECREASE_PLAYBACK_SPEED,
  z as DECREASE_VOLUME,
  V as DOWN_ARROW,
  H as EDIT_CLOSE,
  b as EDIT_CONFIRM,
  B as EDIT_ERROR,
  F as EDIT_SAVING,
  h as EDIT_SUCCESS,
  K as EDIT_TRANSCRIPT,
  f as EDIT_VALIDATION_ERROR,
  Q as FULLSCREEN,
  W as HOURS,
  $ as HOURS_other,
  q as INCREASE_PLAYBACK_SPEED,
  J as INCREASE_VOLUME,
  x as INVERT_COLORS,
  Z as JUMP_TO_PERCENTAGE,
  y as JUMP_TO_START,
  X as KEBAB_MENU,
  j as KEYBOARD_SHORTCUTS,
  k as LANGUAGE,
  w as LEFT_ARROW,
  tt as MAIN_MENU,
  ot as MINUTES,
  it as MINUTES_other,
  nt as MUTE,
  ct as MUTED,
  st as NEXT_CAPTION_LANGUAGE,
  et as NEXT_HIT,
  At as OFF,
  at as ON_TOP,
  Et as OPEN_ANNOTATION_AT,
  Tt as OPEN_COMPLETED_QUIZ_AT,
  _t as OPEN_QUIZ_AT,
  rt as PAUSE,
  St as PLAY,
  Rt as PLAYBACK_SPEED,
  ut as PLAYBACK_SPEED_MESSAGE,
  Nt as PREVIOUS_CAPTION_LANGUAGE,
  lt as PREVIOUS_HIT,
  It as QUALITY,
  Ot as QUALITY_MENU,
  Ct as REPLAY,
  Pt as RESET_PLAYBACK_SPEED,
  Ut as RIGHT_ARROW,
  Lt as SEARCH_TRANSCRIPT_PLACEHOLDER,
  dt as SECONDS,
  Dt as SECONDS_other,
  Mt as SEEK_BACKWARD,
  mt as SEEK_FORWARD,
  pt as SETTINGS,
  vt as SHORTCUT,
  gt as SIDEBAR,
  Gt as SPACE,
  Yt as SPEED_MENU,
  zt as START_AUTOSCROLL,
  Vt as TOGGLE_CAPTIONS,
  Ht as TOGGLE_MUTED,
  bt as TOGGLE_PLAY_PAUSE,
  Bt as TRANSCRIPT_LINES,
  Ft as TRANSCRIPT_LINES_other,
  ht as TRANSCRIPT_LOADING,
  Kt as TRANSCRIPT_LOAD_ERROR,
  ft as TRANSCRIPT_OPTIONS,
  Qt as TRANSCRIPT_RETRY,
  Wt as TRANSCRIPT_UNAVAILABLE,
  $t as UP_ARROW,
  qt as VIDEO_SETTINGS,
  Jt as VOLUME,
  xt as VOLUME_VALUE,
  Zt as default
};
